import { PropsWithChildren } from 'react';

import { Dag, DagProps, DbtDagNode } from '@dbt-labs/dbt-dag';

export type ExplorerDagNode = DbtDagNode & {
  projectId: number;
  environmentId: number;
};

type ExplorerDagProps = PropsWithChildren<DagProps<ExplorerDagNode>> & {
  nodes: ExplorerDagNode[];
};

export const ExplorerDag = (props: ExplorerDagProps) => {
  return <Dag {...props} />;
};
